export default "./images/survio-2SqZ9-reference-nl.png";